import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { reportsActions } from '@src/store/reducers/reportsReducer';

export const createReportsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [reportsActions.GET_INSTANCES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Servers/GetMonitoredServers`);
            const data = response.data;
            next({ type: reportsActions.SET_INSTANCES, payload: { instances: data } });
            return data;
        },
        [reportsActions.GET_ALL_INSTANCES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Servers/AllServers`);
            const data = response.data;
            next({ type: reportsActions.SET_ALL_INSTANCES, payload: { instancesAll: data } });
            return data;
        },
        [reportsActions.GET_SCHEMAS_FOR_REPORT]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Servers/${payload.instanceId}/Schemes/Monitored`);
            const data = response.data;
            next({ type: reportsActions.SET_SCHEMAS_FOR_REPORT, payload: { schemas: data } });
            return data;
        },
        [reportsActions.GET_SCHEMAS_FOR_REPORT_DEAILS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Servers/${payload.instanceId}/Schemes`);
            const data = response.data;
            next({ type: reportsActions.SET_SCHEMAS_FOR_REPORT_DEAILS, payload: { schemasAll: data } });
            return data;
        },
        [reportsActions.GET_AUDIT_REPORT_DETAILS]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Audit/GetAudit`, payload.data);
            const data = response.data;
            next({ type: reportsActions.SET_AUDIT_REPORT_DETAILS, payload: { report_details: data } });
            return data;
        },
        [reportsActions.GET_DEPLOYED_PACKAGES]: async (payload: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Reports/GetDeployedPackages`, payload.data);
            const data = response.data;
            next({ type: reportsActions.SET_DEPLOYED_PACKAGES, payload: { deployed_packages_details: data } });
            return data;
        },
        [reportsActions.GET_AUDIT_REPORT_SUMMERY]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Audit/GetAuditSummerized`, payload.data);
            const data = response.data;
            next({ type: reportsActions.SET_AUDIT_REPORT_SUMMERY, payload: { report_summary: data } });
            return data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/reports.middleware.ts